import React, { Component } from 'react';
import {
   Card, CardBody, Col, Table, Badge, Button, UncontrolledTooltip, Alert,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Redirect, Link } from 'react-router-dom';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import CalendarIcon from 'mdi-react/CalendarIcon';
import PropTypes from 'prop-types';
import swal from 'sweetalert';

import ConfirmStockModal from './ConfirmStockModal';
import CommonService from '../../../services/CommonService';
import SubmitReportModal from './SubmitReportModal';
import TransactionModal from '../../Transactions/components/TransactionModal';
import global from '../../../global';

class StockLists extends Component {
   static propTypes = {
      itemID: PropTypes.string,
   };

   static defaultProps = {
      itemID: null,
   };

   constructor(props) {
      super(props);
      this.currDate = new Date();
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      const { itemID } = props;
      const locationId = global.parseToNumber(this.userdata.location_id) !== 0 && global.parseToNumber(this.userdata.type) !== 1 ? this.userdata.location_id : itemID;
      this.state = {
         list: [],
         inventoryData: {
            pageTitle: 'STOCKS',
            total_beginning: 0,
            total_receive: 0,
            total_out: 0,
            date: Moment(this.currDate).format('MMMM DD, YYYY'),
         },
         formdata: {
            actualCount: 0,
            note: '',
         },
         goTo: false,
         goToPage: '/',
         modal: false,
         errorMsg: '',
         stockStatus: '',
         LeGoTo: false,
         LeGoToPage: '/',
      };
      this.isLoading = false;
      this.toggleModal = this.toggleModal.bind(this);
      this.searchStocks = this.searchStocks.bind(this);
      this.transactionToggle = this.transactionToggle.bind(this);
      // location id
      this.locationId = locationId;
      this.noreports = false;
      this.reportdate = '';
   }

   componentDidMount() {
      this.isLoading = true;
      this.onLoadStocks();
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   handleChange = (e, fieldName = '') => {
      if (fieldName === 'number') {
         const { name, value } = e.target;
         this.setState(prevState => ({
            formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
         }));
      } else if (fieldName === 'date') {
         const date = new Date(e);
         this.setState(prevState => ({
            formdata: {
               ...prevState.formdata,
               inventoryDate: date,
            },
         }));
      } else {
         const { name, value } = e.target;
         this.setState(prevState => ({
            formdata: { ...prevState.formdata, [name]: value },
         }));
      }
   }

   onLoadStocks = async (invtDate = '') => {
      try {
         const storageData = JSON.parse(localStorage.getItem('storeInventoryDate'));
         const inventoryDate = invtDate !== '' ? invtDate : storageData !== null && invtDate === '' ? storageData.date : Moment(new Date()).format('YYYY-MM-DD');
         localStorage.setItem('storeInventoryDate', JSON.stringify({ type: 'logistic', date: inventoryDate }));

         const response = await CommonService.getRows(`stockproducts/locationid/${this.locationId}/inventorydate/${inventoryDate}`);
         if (this.isLoading && response) {
            this.noreports = response.noreports;
            this.reportdate = Moment(response.last_reportdate).format('MMMM DD, YYYY');
            this.setState({
               list: response.inventory,
               inventoryData: {
                  pageTitle: response.location_name,
                  total_beginning: response.total_beginning,
                  total_receive: response.total_in,
                  total_out: response.total_out,
                  date: response.inventory_date,
               },
            });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   LeGoTo = (ev) => {
      this.setState({ LeGoTo: true, LeGoToPage: ev.currentTarget.dataset.href });
   }

   editToggle = (e, id, stockbalance) => {
      e.preventDefault();
      e.stopPropagation();
      this.executeModal = 'submitreport';
      this.toggleModal();
      this.setState({
         formdata: {
            actualCount: stockbalance,
            note: '',
         },
      });
      this.handleSubmit = (ev) => { this.editSubmitInventory(ev, id); };
   }

   editSubmitInventory = (e, id) => {
      e.preventDefault();
      const { formdata, list } = this.state;
      formdata.inventory_control_id = id;
      formdata.location_id = this.locationId;

      try {
         if (formdata.actualCount) {
            const response = CommonService.updateData('updatestockactualcount', formdata);
            if (response) {
               list.filter((resp) => {
                  if (resp.inventory_control_id === id) {
                     resp.stock_balance_actual = formdata.actualCount;
                     resp.flag = 1;
                  }
                 return resp;
               });
               this.setState({ list, modal: false });
            }
         } else {
            this.setState({ errorMsg: 'Required field is empty!' });
         }
      } catch (err) {
         console.log(err.message);
         this.isLoading = false;
      }
   }

   confirmStock(e, controlID, status, quantity = 0) {
      e.preventDefault();
      e.stopPropagation();
      this.executeModal = 'confirmation';
      this.toggleModal();
      this.setState({
         formdata: {
            actualQuantity: quantity,
            note: '',
            controlID,
            status,
            quantity,
         },
         stockStatus: status.toString(),
      });
      // submit form
      this.handleSubmit = (ev) => { this.submitConfirmation(ev); };
   }

   async submitConfirmation(e) {
      e.preventDefault();
      const {
         formdata, locationid,
      } = this.state;
      formdata.locationId = parseInt(locationid, 10) > 0 ? locationid : this.locationId;

      if ((formdata.status === 1 && formdata.actualQuantity) || (formdata.status === 2 && formdata.note)) {
         this.setState({ errorMsg: '' });
         const result = await CommonService.updateData('updatestockstatuscontrol', formdata);
         if (result === true) {
            this.onLoadStocks();
            this.setState({ errorMsg: '', modal: false });
            swal('', 'Successfully updated information!', 'success');
         } else {
            this.setState({ modal: false });
            swal('', 'Failed to update information', 'warning');
         }
      } else {
         this.setState({ errorMsg: 'Required fields are empty.' });
      }
   }

   searchStocks(e) {
      e.preventDefault();
      const { formdata } = this.state;
      const inventoryDate = Moment(formdata.inventoryDate).format('YYYY-MM-DD');
      this.onLoadStocks(inventoryDate);
   }

   transactionToggle() {
      this.toggleModal();
      this.executeModal = 'newtransaction';
      this.handleSubmit = (e) => { this.addTransaction(e); };
   }

   async addTransaction(e) {
      e.preventDefault();
      const form = document.getElementById('store_transaction_form');
      const formdata = new FormData(form);
      formdata.append('location_id', this.locationId);
      formdata.append('user_id', this.userdata.user_id);

      try {
        const result = await CommonService.insertData('addstoretransaction', formdata, false);
         if (result) {
            if (result.msg === true) {
               this.onLoadStocks();
               this.setState({ errorMsg: '', modal: false });

               swal({
                 title: 'New Transaction was added!',
                 text: 'Would you like to add a new transaction?',
                 icon: 'success',
                 closeOnClickOutside: false,
                 buttons: {
                   no: 'NOPE',
                   yes: 'ADD NEW',
                 },
               }).then((name) => {
                 name = name.toLowerCase();

                 if (name === 'yes') {
                   this.transactionToggle();
                 }
               });
             } else {
               this.setState({ errorMsg: result.msg });
            }
         } else {
            swal('', 'Failed to add inventory', 'warning');
         }
      } catch (err) {
        console.log('Error: ', err.message);
      }
    }

   goTo(e, inventoryId) {
      e.preventDefault();
      let pageLink = `/stocks/distribution/${inventoryId}`;
      if (this.userdata.type === '1' || this.userdata.type === '5') {
         pageLink = `/inventory/retailstore/distribution/${inventoryId}`;
      }
      this.setState({ goTo: true, goToPage: pageLink });
   }

   toggleModal() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         list, inventoryData, goTo, goToPage, modal, formdata, errorMsg, stockStatus, LeGoTo, LeGoToPage,
      } = this.state;
      const { itemID } = this.props;

      if (LeGoTo === true) {
         return <Redirect to={{ pathname: LeGoToPage, state: { prevpage: '/stocks/list' } }} />;
      }

      if (goTo === true) {
         return <Redirect to={goToPage} />;
      }

      if (this.userdata.type === '1' && itemID === null) {
         return <Redirect to="/inventory/retailstore" />;
      }

      // for search date
      let inventoryDate = new Date();
      if (localStorage.getItem('storeInventoryDate') !== null) {
         const storageData = JSON.parse(localStorage.getItem('storeInventoryDate'));
         const storageDate = new Date(storageData.date);

         let formdate = new Date();
         if (formdata.inventoryDate) {
            formdate = new Date(formdata.inventoryDate);
         }

         inventoryDate = formdata.inventoryDate !== undefined && formdata.inventoryDate !== formdate ? formdate : storageDate;
      }

      return (
         <Col md={12}>
            {
               this.executeModal === 'newtransaction' ? (
                  <TransactionModal
                    title="Add Transaction"
                    modal={modal}
                    toggle={this.toggleModal}
                    handleSubmit={this.handleSubmit}
                    errorMsg={errorMsg}
                    locUrlParam={this.locationId}
                  />
               ) : this.executeModal === 'confirmation' ? (
                  <ConfirmStockModal
                     modal={modal}
                     toggle={this.toggleModal}
                     handleChange={this.handleChange}
                     postValue={formdata}
                     errorMsg={errorMsg}
                     handleSubmit={this.handleSubmit}
                     stockStatus={stockStatus}
                  />
               ) : (
                  <SubmitReportModal
                     modal={modal}
                     toggle={this.toggleModal}
                     handleChange={this.handleChange}
                     postValue={formdata}
                     errorMsg={errorMsg}
                     handleSubmit={this.handleSubmit}
                  />
               )
            }
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">{this.userdata.type === '1' ? inventoryData.pageTitle : 'Stocks'}</h5>
                     {
                        this.userdata && (this.userdata.type === '1' || this.userdata.type === '5') && (
                        <div className="panel__btns">
                           <Button onClick={this.transactionToggle} className="rounded text-white btn-awesome" size="sm" outline>
                              <i className="fa fa-shopping-cart" />
                              <span>Add New Transaction</span>
                           </Button>
                           <Link className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" to="/inventory/retailstore/list">
                              <i className="fa fa-arrow-left" />
                              <span>Back</span>
                           </Link>
                        </div>
                        )
                     }
                  </div>
                  <div className="panel__content">
                     { this.noreports && (
                        <div className="notif_msg full-width clearfix notheadnotif">
                           <Alert color="danger" className="alert--colored">
                           <div className="alert__content">
                              <div>You have an unsubmitted report from {this.reportdate !== '' ? <strong className="text-red">{this.reportdate}</strong> : 'Yesterday' } inventory.</div>
                           </div>
                           </Alert>
                        </div>
                        )
                     }

                     <div className="stock-box__container">
                        <div className="stock-box outline stock-green">
                           <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                           <h3 className="stock-box__num">{inventoryData && inventoryData.total_beginning ? `${inventoryData.total_beginning} kgs` : 0}</h3>
                           <h4 className="stock-box__text">Beginning Stock</h4>
                        </div>
                        <Button className="stock-box outline stock-blue" onClick={this.LeGoTo} data-href={`/stockstracker/${this.locationId}/stockin/list`}>
                           <div className="stock-box__icon"><i className="fa fa-dolly-flatbed" /></div>
                           <h3 className="stock-box__num">{inventoryData && inventoryData.total_receive ? `${inventoryData.total_receive} kgs` : 0}</h3>
                           <h4 className="stock-box__text">Total Received</h4>
                        </Button>
                        <Button className="stock-box outline stock-red" onClick={this.LeGoTo} data-href={`/stockstracker/${this.locationId}/stocksold/list`}>
                           <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                           <h3 className="stock-box__num">{inventoryData && inventoryData.total_out !== 0 ? `${inventoryData.total_out} kgs` : 0}</h3>
                           <h4 className="stock-box__text">Total Out</h4>
                        </Button>
                        <div className="stock-box stock-aqua">
                           <div className="stock-box__icon"><i className="fa fa-calendar-alt" /></div>
                           <h3 className="stock-box__num">{inventoryData.date}</h3>
                           <h4 className="stock-box__text">Date</h4>
                        </div>
                     </div>
                  </div>
                  <div className="panel__content">
                     {/* Search Form */}
                     <div className="float-right">
                        <form className="form form--horizontal" onSubmit={this.searchStocks}>
                           <div className="form__form-group m-b-0">
                              <span className="form__form-group-label text-right">Date:</span>
                              <div className="form__form-group-field">
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <div className="date-picker">
                                    <DatePicker
                                       name="inventoryDate"
                                       selected={inventoryDate}
                                       popperPlacement="top"
                                       onChange={e => this.handleChange(e, 'date')}
                                    />
                                 </div>
                                 <button type="submit" className="form__form-group-button bg-primary"><i className="fa fa-search" /></button>
                              </div>
                           </div>
                        </form>
                     </div>
                     {/* Table */}
                     <Table responsive hover striped>
                        <thead>
                           <tr>
                              <th width="20%">Product Name</th>
                              <th className="text-center">Beginning Stock</th>
                              <th className="text-center">Pending Stock</th>
                              <th className="text-center">Total Received</th>
                              <th className="text-center">Total Out</th>
                              <th className="text-center">Remaining Stock</th>
                              <th className="text-center">Actual Count</th>
                              <th className="text-center">Date</th>
                              <th className="text-center">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                        {
                           list !== false || list.length > 0 ? list.map((item, i) => {
                              item.status = parseInt(item.status, 10);
                              const controlID = item.inventory_control_id;
                              const pendingQuantity = (item.stock_receive_pending !== '0' ? item.stock_receive_pending : 0);

                              return (
                              <tr key={item.inventory_control_id} onClick={e => this.goTo(e, item.inventory_control_id)} className={`text-center ${inventoryData.date !== item.date_added ? 'bg-red-l' : ''}`}>
                                 <td className="text-left">{item.product_name}</td>
                                 <td>{item.stock_beginning !== '0' ? `${item.stock_beginning} kg.` : 0}</td>
                                 <td><Badge color="warning">{item.stock_receive_pending !== '0' ? `${item.stock_receive_pending} kg.` : 0}</Badge></td>
                                 <td>{item.stock_receive !== '0' ? `${item.stock_receive} kg.` : 0}</td>
                                 <td>{item.stock_out !== '0' ? `${item.stock_out} kg.` : 0}</td>
                                 <td>{item.stock_balance !== '0' ? `${item.stock_balance} kg.` : 0}</td>
                                 <td>{item.stock_balance_actual !== '0' ? `${item.stock_balance_actual} kg.` : 0}</td>
                                 <td>{item.date_added}</td>
                                 <td>
                                    {
                                       item.stock_receive_pending !== '0' && item.flag === '0' ? (
                                          <span>
                                             {/* Approve */}
                                             <Button color="success" className="btn-xs" title="Approve" onClick={e => this.confirmStock(e, controlID, 1, pendingQuantity)} id={`approvebtn${i + 1}`} outline><span className="fa fa-check" /></Button>
                                             <UncontrolledTooltip placement="bottom" target={`approvebtn${i + 1}`}>Approve</UncontrolledTooltip>
                                             {/* Deny */}
                                             <Button color="danger" className="btn-xs" title="Deny" onClick={e => this.confirmStock(e, controlID, 2, pendingQuantity)} id={`denybtn${i + 1}`} outline><span className="fa fa-times" /></Button>
                                             <UncontrolledTooltip placement="bottom" target={`denybtn${i + 1}`}>Deny</UncontrolledTooltip>
                                          </span>
                                       ) : ''
                                    }
                                    {
                                       item.flag === '0' ? (
                                          <span>
                                             {/* submit report */}
                                             <Button color="info" id={`forwardTP${i}`} className="btn-xs" onClick={e => this.editToggle(e, item.inventory_control_id, item.stock_balance)} outline><span className="fa fa-share" /></Button>
                                             <UncontrolledTooltip placement="bottom" target={`forwardTP${i}`}>Submit Report</UncontrolledTooltip>
                                          </span>
                                       ) : '-'
                                    }
                                 </td>
                              </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="9">No data available..</td>
                              </tr>
                           )
                        }
                        </tbody>
                     </Table>
                  </div>
                  <div className="panel__footer">
                     <span><span className="p-x-7 m-r-10 bg-red-l" />{"Yesterday's Inventory"}</span>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(StockLists);
